import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <h4 className="text-xl font-bold text-background-50 mb-4" style={{ fontFamily: "'ZCOOL QingKe HuangYou', cursive" }}>
              黑料不打烊
            </h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              全天候娱乐黑料聚合平台，24小时不间断为你推送最新、最劲爆的娱乐圈黑料、明星丑闻与网红爆料。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              更多分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              关注我们
            </h4>
            <p className="text-sm text-foreground-400 mb-4">
              第一时间获取最新爆料，不错过任何热点瓜
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-700 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-700 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-md bg-background-700 hover:bg-primary-500 text-foreground-300 hover:text-background-50 transition-colors cursor-pointer" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料不打烊 - 版权所有 | 本站内容仅供娱乐参考，不构成任何建议
          </p>
          <div className="flex gap-4">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
              关于我们
            </Link>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}